/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Football(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={160}
        y1={96}
        x2={96}
        y2={160}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={124.68629}
        y1={102.05887}
        x2={153.94113}
        y2={131.31371}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={102.05887}
        y1={124.68629}
        x2={131.31371}
        y2={153.94113}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={148.22436}
        y1={36.22436}
        x2={219.77587}
        y2={107.77587}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={36.22399}
        y1={148.22399}
        x2={107.77612}
        y2={219.77612}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default Football;
